import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    credentials: {
        host: "ofiletransfer.com",
        user: "Testmaster",
        password: "Welcome@123",
        port: 6535
    },
    isConnected: false,
    transfers: []
};

const ftpSlice = createSlice({
    name: 'ftp',
    initialState,
    reducers: {
        setCredetials: (state, action) => {
            state.credentials = action.payload
            state.isConnected = true
        },
        setCxnStatus: (state, action) => {
            state.isConnected = action.payload
        },
        addTransfer: (state, action) => {
            state.transfers.push(action.payload)
        },
        completeTransfer: (state, action) => {
            const index = state.transfers.findIndex(transfer => transfer.id === action.payload.id)
            state.transfers[index].status = 1
            state.transfers[index].timeElapsed = action.payload.timeElapsed
        }
    }
});

export const ftpActions = ftpSlice.actions;

export default ftpSlice;